<mat-card>
  <mat-card-header class="mat-mdc-card-header-has-actions">
    <mat-card-title style="display: flex">
      <span class="card-header-text">Search Criteria</span>
      <span class="card-header-actions">
        <button mat-mini-fab color="none" [matMenuTriggerFor]="addFilterMenu"><mat-icon name="playlist-icon">playlist_add</mat-icon></button>
        <mat-menu #addFilterMenu="matMenu" class="mat-mdc-menu-chip-menu">
          @if (areAllFiltersApplied()) {
            <div style="margin: 5px;">
              <em>
                All filterable properties have been applied.
                Either edit the ones you already have selected, or remove some.
              </em>
            </div>
          }
          @if (!areAllFiltersApplied()) {
            <mat-chip-listbox>
              @for (filterCategory of filterCategories(); track filterCategory) {
                @if (doesCategoryHaveAvailableFilters(filterCategory)) {
                  <mat-hint style="width: 100%; font-size: 75%; margin-left: 6px; margin-right: 4px">{{filterCategory.categoryName}}</mat-hint>
                  <mat-divider style="padding-bottom: 5px; width: 100%; margin-left: 4px; margin-right: 4px"></mat-divider>
                  @for (filter of filterCategory.filters; track filter) {
                    @if (!isFilterInUse(filter)) {
                      <mat-chip-option class="mat-mdc-chip-mini" [disabled]="filter.disabled" (click)="addFilter(filter)">{{filter.name}}</mat-chip-option>
                    }
                  }
                }
              }
            </mat-chip-listbox>
          }
        </mat-menu>
      </span>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (selectedFilters() == null || selectedFilters().length == 0) {
      <div>
        <em>You have no filters applied. Select the <mat-icon class="mat-mdc-icon-inline-text">playlist_add</mat-icon> button above to add some.</em>
      </div>
    }

    @for (selectedFilter of selectedFilters(); track selectedFilter) {
      <div>
        @if (selectedFilter.filter.inputType !== 'dateRange') {
          <mat-form-field>
            <mat-label>{{ selectedFilter.filter.name }}</mat-label>
            @if (selectedFilter.filter.inputType === 'text') {
              <input matInput #SearchField [(ngModel)]="selectedFilter.searchValue">
            }
            @if (selectedFilter.filter.inputType === 'selectSingle' || selectedFilter.filter.inputType === 'selectMulti') {
              <mat-select panelClass="standard-modal-panel"
                [(value)]="selectedFilter.searchValue"
                [multiple]="selectedFilter.filter.inputType === 'selectMulti'">
                @for (option of selectedFilter.filter.options; track option) {
                  <mat-option [value]="option.value">
                    {{option.display}}
                  </mat-option>
                }
              </mat-select>
            }
            @if (selectedFilter.filter.inputType === 'autocomplete') {
              <ftms-typeahead name="autocomplete" [items]="selectedFilter.filter.options" multiple
              [(ngModel)]="selectedFilter.searchValue"></ftms-typeahead>
            }
            @if (selectedFilter.filter.inputType === 'species') {
              <mat-chip-grid #chipList (click)="openSpeciesModal(selectedFilter.filter.name)">
                @for (chip of selectedFilter.searchValue; track chip) {
                  <mat-chip-row (removed)="removeChip(chip, selectedFilter.filter.name)" [matTooltip]="chip.Description">
                    {{chip.Code}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-row>
                }
                <input [ngClass]="{'mat-mdc-chip-input-display': selectedFilter.searchValue == undefined || selectedFilter.searchValue.length === 0, 'mat-mdc-chip-input-hide': selectedFilter.searchValue != undefined && selectedFilter.searchValue.length > 0}" [matChipInputFor]="chipList">
              </mat-chip-grid>
            }
            @if (selectedFilter.filter.inputType === 'species') {
              <button class="chip-add-btn" matSuffix mat-mini-fab color="none" (click)="openSpeciesModal(selectedFilter.filter.name)">
                <mat-icon>add</mat-icon>
              </button>
            }
            @if (selectedFilter.filter.inputType === 'chipList') {
              <mat-chip-grid #chipList>
                @for (chip of selectedFilter.searchValue; track chip) {
                  <mat-chip-row (removed)="removeChip(chip, selectedFilter.filter.name)" [matTooltip]="chip.Description">
                    {{chip}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-row>
                }
                <input [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeyCodes" (matChipInputTokenEnd)="addChip($event, selectedFilter.filter.name)" />
              </mat-chip-grid>
            }
            @if (selectedFilter.filter.inputType === 'contractor') {
              <mat-chip-grid #contractorChip (click)="openContractorModal(selectedFilter.filter.name)">
                @for (chip of selectedFilter.searchValue; track chip) {
                  <mat-chip-row (removed)="removeChip(chip, selectedFilter.filter.name)" [matTooltip]="chip.Description">
                    {{chip.Code}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-row>
                }
                <input [ngClass]="{'mat-mdc-chip-input-display': selectedFilter.searchValue == undefined || selectedFilter.searchValue.length === 0, 'mat-mdc-chip-input-hide': selectedFilter.searchValue != undefined && selectedFilter.searchValue.length > 0}" [matChipInputFor]="contractorChip">
              </mat-chip-grid>
            }
            @if (selectedFilter.filter.inputType === 'contractor') {
              <button class="chip-add-btn" matSuffix mat-mini-fab color="none" (click)="openContractorModal(selectedFilter.filter.name)">
                <mat-icon>add</mat-icon>
              </button>
            }
            @if (selectedFilter.filter.inputType === 'date') {
              <input matInput [matDatepicker]="picker" [(ngModel)]="selectedFilter.searchValue" name="picker">
            }
            @if (selectedFilter.filter.inputType === 'date') {
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            }
            <mat-datepicker #picker></mat-datepicker>
            @if (selectedFilter.filter.inputType === 'none') {
              <input matInput disabled [(ngModel)]="selectedFilter.searchValue">
            }
            <mat-icon matSuffix (click)="removeFilter(selectedFilter)">close</mat-icon>
            @if (selectedFilter.filter.hintText != null) {
              <mat-hint align="end" [innerHTML]="selectedFilter.filter.hintText"></mat-hint>
            }
          </mat-form-field>
        }
        <div>
          @if (selectedFilter.filter.inputType === 'dateRange') {
            <mat-form-field>
              <mat-label>{{ selectedFilter.filter.name }} Start</mat-label>
              <input matInput [matDatepicker]="startDateRangePicker" [(ngModel)]="selectedFilter.StartDateSearchValue" name="startDateRangePicker">
              <mat-datepicker-toggle matSuffix [for]="startDateRangePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDateRangePicker></mat-datepicker>
              @if (selectedFilter.filter.hintText != null) {
                <mat-hint align="end" [innerHTML]="selectedFilter.filter.hintText"></mat-hint>
              }
            </mat-form-field>
          }
          @if (selectedFilter.filter.inputType === 'dateRange') {
            <mat-form-field>
              <mat-label>{{ selectedFilter.filter.name }} End</mat-label>
              <input matInput [matDatepicker]="endDateRangePicker" [(ngModel)]="selectedFilter.EndDateSearchValue" name="endDateRangePicker">
              <mat-datepicker-toggle matSuffix [for]="endDateRangePicker"></mat-datepicker-toggle>
              <mat-datepicker #endDateRangePicker></mat-datepicker>
              @if (selectedFilter.filter.hintText != null) {
                <mat-hint align="end" [innerHTML]="selectedFilter.filter.hintText"></mat-hint>
              }
              <button matSuffix mat-mini-fab color="none" aria-label="Clear" (click)="removeFilter(selectedFilter)">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          }
        </div>
      </div>
    }


  </mat-card-content>
  <mat-card-actions class="filter-card-actions">
    <button mat-mini-fab matTooltip="Collapse Search Criteria" (click)="ToggleSearchSection()">
      <mat-icon>unfold_less</mat-icon>
    </button>
    <button class="hidden-sm hidden-xs" mat-mini-fab color="none" [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @if (enableFavorites() == true) {
        <button mat-menu-item (click)="clearFavorites()">Clear Favorites</button>
      }
      <button mat-menu-item (click)="clearSearch()" [disabled]="selectedFilters() == null || selectedFilters().length == 0">Clear Search Filters</button>
    </mat-menu>
    <span style="flex: 1 1 auto;"></span>
    <button mat-mini-fab color="none" matTooltip="Apply last used filters" (click)="fetchPreviousSearchParameters()" [disabled]="isLoading">
      @if (!isLoading) {
        <mat-icon>history</mat-icon>
      }
      @if (isLoading) {
        <mat-spinner [diameter]="20"></mat-spinner>
      }
    </button>

    <button class="hidden-md hidden-lg" mat-raised-button (click)="clearSearch()" [disabled]="selectedFilters() == null || selectedFilters().length == 0">Clear</button>
    <button class="hidden-xs hidden-md" mat-raised-button color="primary" (click)="OnSearchButtonClick()">Search</button>
    <button class="hidden-sm hidden-lg" mat-mini-fab color="primary" matTooltip="Search" (click)="OnSearchButtonClick()">
      <mat-icon>search</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>